import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createClient } from '@kairos/supabase/browser'

import { env } from './env'
import { initSentry } from './lib/sentry'
import { initWebVitals } from './lib/web-vitals'
import { Providers } from './providers'
import './styles/index.css'

/**
 * Initialize observability before React mounts so we capture errors during
 * the very first render. Sentry no-ops if `VITE_SENTRY_DSN` is empty (dev
 * default), so this is safe in all environments.
 */
initSentry()

/**
 * Prime the `@kairos/supabase/browser` singleton with our validated env
 * BEFORE React mounts. The shared package's own env resolution only reads
 * `import.meta.env.VITE_SUPABASE_*` literally so Vite can statically inline
 * those values; the monorepo's shared `.env.local` exposes them under the
 * Next.js-friendly `NEXT_PUBLIC_SUPABASE_*` names. By calling `createClient`
 * with explicit values here, the singleton captures the right credentials
 * regardless of which prefix the env file uses.
 */
createClient({
  url: env.VITE_SUPABASE_URL,
  anonKey: env.VITE_SUPABASE_ANON_KEY,
})

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Missing #root element in index.html')
}

createRoot(rootElement).render(
  <StrictMode>
    <Providers />
  </StrictMode>,
)

// Web Vitals reporting — non-blocking, fires after first interactive frame.
initWebVitals()
